import { VesselTypeName } from 'app/types/types';

export const SHIP_COLORS = ['#14F353', '#1488F3', '#A585FF', '#F880D7', '#F35714', '#F3C214', '#52CEF5', '#CDCDCD'];

export const SHIP_TYPES_COLORS = [
  {
    codes: [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
    type: 'VesselTypeCargo',
    color: '#14F353',
  },
  {
    codes: [64, 65, 66, 67, 68, 69, 60, 61, 62, 63],
    type: 'VesselTypePassenger',
    color: '#1488F3',
  },
  {
    codes: [48, 49, 40, 41, 42, 43, 44, 45, 46, 47],
    type: 'VesselTypeSpeed',
    color: '#A585FF',
  },
  {
    codes: [36, 37],
    type: 'VesselTypePleasure',
    color: '#F880D7',
  },
  {
    codes: [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
    type: 'VesselTypeTanker',
    color: '#F35714',
  },
  {
    codes: [30],
    type: 'VesselTypeFishing',
    color: '#F3C214',
  },
  {
    codes: [32, 33, 34, 35, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 31],
    type: 'VesselTypeSpecialTug',
    color: '#52CEF5',
  },
  {
    codes: [-10],
    color: '#CDCDCD',
    type: 'VesselTypeOther',
  },
];
export const VesselTypesMap: Map<VesselTypeName, any> = new Map([
  [
    'Cargo',
    {
      codes: [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
      type: 'VesselTypeCargo',
      color: '#14F353',
    },
  ],

  [
    'Fishing',
    {
      codes: [30],
      type: 'VesselTypeFishing',
      color: '#F3C214',
    },
  ],
  [
    'Passenger',
    {
      codes: [64, 65, 66, 67, 68, 69, 60, 61, 62, 63],
      type: 'VesselTypePassenger',
      color: '#1488F3',
    },
  ],
  [
    'Speed',
    {
      codes: [48, 49, 40, 41, 42, 43, 44, 45, 46, 47],
      type: 'VesselTypeSpeed',
      color: '#A585FF',
    },
  ],
  [
    'Pleasure',
    {
      codes: [36, 37],
      type: 'VesselTypePleasure',
      color: '#F880D7',
    },
  ],
  [
    'TugOrSpecialCraft',
    {
      codes: [32, 33, 34, 35, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 31],
      type: 'VesselTypeSpecialTug',
      color: '#52CEF5',
    },
  ],
  [
    'Tanker',
    {
      codes: [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
      type: 'VesselTypeTanker',
      color: '#F35714',
    },
  ],
  [
    'Other',
    {
      // codes: [-10],
      codes: [
        -10, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 90,
      ],
      color: '#CDCDCD',
      type: 'VesselTypeOther',
    },
  ],
]);

export const motionlessSpeed = 0.3;
